// src/legal/legalVersions.ts

export const LEGAL_VERSIONS = {
  TERMS: "2026-04-07",
  PRIVACY: "2026-04-07",
  PAID_SERVICE: "2026-04-07",
  REFUND: "2026-04-07",
  NOTICE: "2026-04-07",
  DISCLAIMER: "2026-04-07",
  AGE_OVER_14: "2026-04-07",
  MARKETING: "2026-04-07",
} as const;

export type LegalVersionKey = keyof typeof LEGAL_VERSIONS;
